import { atom } from 'recoil';

export const LowerHeader = atom({
    key: 'LowerHeader',
    default: null,
});

export const PostMessage = atom({
    key:'post_message',
    default: null
});


export const FilterGroupAtom = atom({
    key:'FilterGroupAtom',
    default: {}
});

export const IsIpad = atom({
    key:'Ipad_Device',
    default: false
});
export const searchTextAtom = atom({
    key:'searchText__',
    default: ''
});





